export default __webpack_public_path__ + "static/media/vrb.8a7849eb.svg";